import React from 'react'
import { FETCH_STATUS } from '../../../infrastructure/fetch/constants'
import Box from '../../../components/Box'
import Spinner from '../../../components/Spinner'
import Error from '../../../components/Error'

const KeyMetricsWidget = ({ status, data, children, retry }) => {
    const wrapInBox = component => (
        <Box>
            <div className="flex ai-center" style={{ minHeight: 320 }}>
                {component}
            </div>
        </Box>
    )

    if (status === FETCH_STATUS.REQUESTED) {
        return wrapInBox(<Spinner />)
    }

    if (status === FETCH_STATUS.FAILED) {
        return wrapInBox(<Error retry={retry} />)
    }

    if (data.length === 0) {
        return wrapInBox(<em>No results found</em>)
    }

    return children
}

export default KeyMetricsWidget
